import React from "react";
import PropTypes from "prop-types";
import {
	Box,
	Typography,
	useTheme,
	useMediaQuery,
	makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	headingContainer: {
		margin: theme.spacing(4, 0, 2, 0),
		[theme.breakpoints.down("sm")]: {
			margin: theme.spacing(18, 3, 0, 3),
		},
	},
	heading: {
		textAlign: "center",
		color: theme.palette.common.white,
	},
	headingBreak: {
		[theme.breakpoints.down("sm")]: {
			marginTop: theme.spacing(5),
		},
	},
}));

export default function HeadingSection({ headingProps }) {
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	return (
		<Box className={classes.headingContainer}>
			{isMobile ? (
				<Typography className={classes.heading} variant="h1">
					{headingProps.title}
					{" " + headingProps.subTitle}
				</Typography>
			) : (
				<>
					<Typography className={classes.heading} variant="h1">
						{headingProps.title}
					</Typography>
					<Typography className={`${classes.heading}`} variant="h1">
						{headingProps.subTitle}
					</Typography>
				</>
			)}
		</Box>
	);
}

HeadingSection.propTypes = {
	headingProps: PropTypes.shape({
		title: PropTypes.string.isRequired,
		subTitle: PropTypes.string.isRequired,
	}).isRequired,
};
